var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "infoWindow", staticClass: "storefinder__infoWindow" },
    [
      _c("h4", [_vm._v(_vm._s(_vm.store.company))]),
      _vm._v(" "),
      _c("small", { staticClass: "distance" }, [
        _vm._v(_vm._s(Number(_vm.store.distance.toFixed(1))) + " km"),
      ]),
      _vm._v("\n  " + _vm._s(_vm.store.address)),
      _c("br"),
      _vm._v("\n  " + _vm._s(_vm.store.zip) + " " + _vm._s(_vm.store.city)),
      _c("br"),
      _vm._v(" "),
      _vm.store.www
        ? _c("a", { attrs: { href: _vm.store.www } }, [
            _vm._v(_vm._s(_vm.store.www)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "ul",
        _vm._l(_vm.store.categories, function (category) {
          return _c("li", [_vm._v(_vm._s(category.title))])
        }),
        0
      ),
      _vm._v(" "),
      _c("p", [
        _c(
          "a",
          {
            staticClass: "button",
            attrs: {
              href: "https://maps.google.com/?daddr=" + _vm.store._string,
              target: "_blank",
            },
          },
          [_vm._v("Find us")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }